exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".radio-filter-accordion.is-open .radio-filter-selection{display:none}.radio-filter-accordion.is-closed .radio-filter-selection{display:block;font-size:1.2rem;max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/facets/radio-button-filter/radio-button-filter.scss
// module id = 5256
// module chunks = 0